const ITEMS = [
  "HIGH-CONVERSION WEBSITES",
  "AI VOICE AGENTS",
  "WHATSAPP AUTOMATION",
  "WEBSITE CHAT AGENTS",
  "INSTAGRAM & FACEBOOK AI",
  "OMNICHANNEL LEAD CAPTURE",
  "24/7 CUSTOMER RESPONSE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-slate-950/60 py-4 overflow-hidden" aria-hidden="true">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono2 text-[11px] sm:text-xs tracking-[0.3em] text-slate-500 whitespace-nowrap"
              >
                <span className="px-6">{item}</span>
                <span className="text-blue-500/70 text-[9px]">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
